import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useFetchQuestion from "../hooks/useFetchQuestion";
import useCreateQuestion from "../hooks/useCreateQuestion";
import "./AdminCreateQuestionScreen.css";

export default function AdminCreateQuestionScreen() {
    const { domainId, categoryId, questionId } = useParams();
    const navigate = useNavigate();

    const { question, loading, error: fetchError } = useFetchQuestion(domainId, categoryId, questionId);
    const { createOrUpdateQuestion, saving, error: saveError } = useCreateQuestion();

    const [questionNumber, setQuestionNumber] = useState("");
    const [orderId, setOrderId] = useState("");
    const [questionText, setQuestionText] = useState("");
    const [detailedAnswer, setDetailedAnswer] = useState("");
    const [compactAnswer, setCompactAnswer] = useState("");
    const [prompt, setPrompt] = useState("");

    useEffect(() => {
        if (question) {
            setQuestionNumber(question.questionNumber || "");
            setOrderId(question.orderId || "");
            setQuestionText(question.question || "");
            setDetailedAnswer(question.detailedAnswer || "");
            setCompactAnswer(question.compactAnswer || "");
            setPrompt(question.prompt || "");
        }
    }, [question]);

    const handleSave = async () => {
        const data = {
            questionNumber,
            orderId,
            question: questionText,
            detailedAnswer,
            compactAnswer,
            prompt,
        };

        const result = await createOrUpdateQuestion(domainId, categoryId, data, questionId);
        if (result.success) {
            alert(questionId ? "✅ Question updated successfully!" : "✅ Question created successfully!");
            navigate(-1);
        } else {
            alert("❌ Failed to save question.");
        }
    };

    return (
        <div className="create-question-page">
            <div className="form-header">
                <h2>{questionId ? "Edit Question" : "Create Question"}</h2>
            </div>

            <div className="form-scroll-container">
                {loading ? (
                    <p>Loading question...</p>
                ) : fetchError ? (
                    <p className="error-text">{fetchError}</p>
                ) : (
                    <>
                        <div className="form-row">
                            <div className="form-group">
                                <label className="field-label">Question Number</label>
                                <input
                                    type="text"
                                    className="input-box"
                                    value={questionNumber}
                                    onChange={(e) => setQuestionNumber(e.target.value)}
                                    placeholder="Example: Q1"
                                />
                            </div>

                            <div className="form-group">
                                <label className="field-label">Order ID</label>
                                <input
                                    type="number"
                                    className="input-box"
                                    value={orderId}
                                    onChange={(e) => setOrderId(e.target.value)}
                                    placeholder="Display order"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="field-label">Question</label>
                            <textarea
                                className="input-box textarea-box question-textarea"
                                value={questionText}
                                onChange={(e) => setQuestionText(e.target.value)}
                                rows={8}
                                placeholder="Write the full interview question here..."
                            />
                        </div>

                        <div className="form-group">
                            <label className="field-label">Detailed Answer</label>
                            <textarea
                                className="input-box textarea-box detailed-answer-textarea"
                                value={detailedAnswer}
                                onChange={(e) => setDetailedAnswer(e.target.value)}
                                rows={14}
                                placeholder="Write the complete answer, explanation, examples, and important points..."
                            />
                        </div>

                        <div className="form-group">
                            <label className="field-label">Compact Answer</label>
                            <textarea
                                className="input-box textarea-box compact-answer-textarea"
                                value={compactAnswer}
                                onChange={(e) => setCompactAnswer(e.target.value)}
                                rows={7}
                                placeholder="Short answer shown for quick review..."
                            />
                        </div>

                        <div className="form-group">
                            <label className="field-label">Prompt</label>
                            <textarea
                                className="input-box textarea-box prompt-textarea"
                                value={prompt}
                                onChange={(e) => setPrompt(e.target.value)}
                                rows={7}
                                placeholder="Optional evaluation prompt or guidance..."
                            />
                        </div>

                        {(saveError || fetchError) && (
                            <p className="error-text">{saveError || fetchError}</p>
                        )}
                    </>
                )}
            </div>

            <div className="form-footer">
                <button className="save-btn" onClick={handleSave} disabled={saving}>
                    {saving
                        ? "Saving..."
                        : questionId
                            ? "Update Question"
                            : "Save Question"}
                </button>
                <button className="back-btn" onClick={() => navigate(-1)}>
                    ← Back
                </button>
            </div>
        </div>
    );
}
